<script>
export default {
  name: "InsuranceInvoice",

  data() {
    return {
      items: [],
      invoiceItems: {},
     patient: {},
      footerMessage: {},
      insuranceDetails:{},
      organizations:{}
    };
  },

  computed: {
    grandTotal() {
      if (!this.invoiceItems.invoiceItems.length) return 0;

      return this.invoiceItems.invoiceItems
        .map((item) => parseFloat(item.insuranceAmountPaid))
        .reduce((amt, sum) => sum + amt,0);
    },
  },

  mounted() {
    this.$root.loading = true;
    Promise.all([ 
     // this.fetchInvoiceItems(), 
      //this.fetchPatient(), 
      this.fetchInvoiceDetails(),
      this.fetchInsuranceDetails(),
      this.fetchMessage(), ])
      .then(() => {
        this.$root.loading = false;
        setTimeout(() => {
          window.print();
        }, 250);
      })
      .catch(() => {
        this.$root.loading = false;
      });
  },

  methods: {
    fetchPatient() {
      let url = `PatientRegistration/GetSpecificPatient`;
      url += `?PatientID=${this.$route.params.patientID}`;

      return this.$http
        .get(url)
        .then(({ data }) => {
          this.patient = data.length ? data[0] : {};
        })
        .catch(() => {});
    }, fetchInvoiceDetails() {
      let url = `AccountsReports/GetInvoiceDetailItems`;

      return this.$http
        .get(`${url}?InvoiceNo=${this.$route.params.invoiceNO}`)
        .then((response) => {
          this.invoiceItems = response.data;
        })
        .catch(() => {});
    },


    fetchInvoiceItems() {
      let url = `Accounts/GetInvoiceDetails`;
      url += `?InvoiceNo=${this.$route.params.invoiceNO}`;

      return this.$http
        .get(url)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(() => {});
    },
    
    fetchInsuranceDetails() {
            if(!parseInt(this.$route.params.organization)) return Promise.reject();

            let url = `MasterData/GetSpecificOrganization`;
                url += `?OrganizationId=${this.$route.params.organization}`;

            return this.$http.get(url).then(({data}) => {
                    this.insuranceDetails = data.length ? data[0] : {};
                }).catch(() => {});
        },
    fetchMessage() {
      let url = `MasterData/GetSpecificOrganizationMessageforGroup`;
      url += `?Group=Invoice`;

      return this.$http.get(url).then(({ data }) => {
        this.footerMessage = data.length ? data[0] : {};
      });
    },
  },
};
</script>
<template>
  <div class="flex flex-wrap">
    <tail-address-header></tail-address-header>
    <div class="flex w-full border-t-dotted border-t-2 border-t-black-600">
                <h5 class="w-full font-bold text-center">INVOICE FOR TREATMENT 
              </h5>
            </div>
               <div class="w-full flex flex-row p-2 bg-gray-300 mt-2">
                <div class="flex-1 p-tiny" >  
                    <h5 class="font-bold text-sm uppercase" v-if="$root.checkAuth('ViewDateOnInvoicePrintOut')">Date:{{invoiceItems.invoiceDetails[0].date|dateFormat}}</h5> 
                    
                </div>
                <div class="flex-1 p-tiny">
                   <h5 class="font-bold text-sm uppercase"> Invoice No: {{$route.params.invoiceNO}}</h5> 
                </div>
            </div>  
             <tail-stamp></tail-stamp>
   
            <div class="flex-1">
                    <div class="w-full flex flex-col content-start">
                       
                        <div class="flex-1 p-1">
                            <h5 class="font-bold text-sm uppercase">Invoice To</h5>
                        </div>
                        <!-- <div class="w-1/2 p-tiny">
                            <label for="grid-insurance" class="label-control">Main Insurance</label>
                            <select v-model.number="main" id="grid-insurance" class="input-control input-sm text-xs">
                                <option value="0">select main insurance</option>
                                <option v-for="insurance in invoiceLines.combinedPaymentnInvoiceDetails" 
                                    :key="insurance.organizationID" 
                                    :value="insurance.organizationID">{{insurance.organization}}</option>
                            </select>
                        </div> -->
                        <div class="w-1/2 p-tiny">
                             <h5 class="font-bold text-sm uppercase"> {{invoiceItems.invoiceDetails[0].organization ||`-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">Address: {{insuranceDetails.postalAddress || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">Contact: {{insuranceDetails.cellphone || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">Scheme: {{insuranceDetails.scheme || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">Package: {{insuranceDetails.package || `-`}}</h5>
                        </div>
                    </div>
                </div>
                <div class="flex-1">
                    <div class="w-full flex flex-col content-start p-1">
                        <div class="flex-1 p-1">
                            <h5 class="font-bold text-sm uppercase">Bill Details</h5>
                        </div>
                        <div class="flex-1 p-tiny">

                            <h5 class="font-medium text-sm capitalize">Name: {{invoiceItems.invoiceDetails[0].patient}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">MRN:{{invoiceItems.invoiceDetails[0].patientID || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">OP: {{ invoiceItems.invoiceDetails[0].opfileno || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">IP: {{invoiceItems.invoiceDetails[0].ipfileno || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">DOB: {{invoiceItems.invoiceDetails[0].ipfileno || `-`}}</h5>
                        </div>
                    </div>
                </div>
                <div class="flex-1">
                    <div class="w-full flex flex-col content-start p-1">
                        <div class="flex-1 p-1">
                            <h5 class="font-bold text-sm uppercase">Principal Details</h5>
                        </div>
                        <div class="flex-1 p-tiny">

                            <h5 class="font-medium text-sm capitalize">
                                Name: {{ invoiceItems.invoiceDetails[0].patient || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">
                                Member No:{{ invoiceItems.invoiceDetails[0].memberno || `-` }}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">
                                Member ID: {{ invoiceItems.invoiceDetails[0].patientIDNo || `-` }}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">
                                Employer: {{ invoiceItems.invoiceDetails[0].employer || `-` }}</h5>
                        </div>
                    </div>
                </div> 
    <!-- <div class="flex-1 my-2 text-center p-1 border-b-2">
      <h5 class="font-bold">INSURANCE INVOICE</h5>
    </div>
    <div
      class="w-full flex flex-row w-full mt-1 border-t-2 border-gray-400 px-1"
    >
      <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">Name: {{ patient.names }}</h5>
      </div>
      <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">MRN: {{ patient.patienT_ID }}</h5>
      </div>
      <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">IP NO: {{ patient.ipfileno }}</h5>
      </div>
      <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">OP NO: {{ patient.opfileno }}</h5>
      </div>
      <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">VisitNO: {{ patient.visitNo }}</h5>
      </div>
    </div>
    <div class="w-full flex flex-wrap">
      <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">Insurance: {{ patient.pMode }}</h5>
      </div>
      <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">
          Date: {{ items.length ? $root.formatDate(items[0].date) : `-` }}
        </h5>
      </div>
    </div>
    <div class="flex-1 my-2 text-center p-1 border-b-2">
      <h5 class="font-bold text-base">
        INVOICE NO: {{ this.$route.params.invoiceNO }}
      </h5>
    </div> -->

            <!-- <div class="w-full flex flex-wrap p-1">
            <div class="flex-1">
                <h5 class="w-full font-bold text-right">Date: 
               <span class="text-blue-800">{{ invoiceItems.invoiceDetails[0].date|dateFormat }}</span></h5>
            </div>
            <div class="flex-1">
                <h5 class="w-full font-bold text-left pl-2">Ref/Invoice No: 
               <span class="text-blue-800">{{ this.$route.params.invoiceNO }}</span></h5> 
            </div>
            </div>
           <div class="w-full flex flex-wrap p-1 border-t-dotted border-t-2 border-t-black-600">
            <div class="flex-1">
                <h5 class="w-full font-bold text-center">To: 
               <span class="text-blue-800">{{ invoiceItems.invoiceDetails[0].organization ||`-` }}</span></h5>
            </div> </div>
            <div class="w-full flex flex-wrap p-1 border-b-dotted border-b-2 border-b-black-600 border-t-dotted border-t-2 border-t-black-600">
                <h5 class="w-full font-bold text-center">Patient  </h5>
            <div class="flex-2">
                <h6 class="w-full font-bold text-right">Name: 
               <span class="text-blue-800">{{ invoiceItems.invoiceDetails[0].patient }}</span></h6>
            </div>
            <div class="flex-1">
                <h6 class="w-full font-bold text-center">OP File No: 
               <span class="text-blue-800">{{ invoiceItems.invoiceDetails[0].opfileno || `-` }}</span></h6>
            </div>
            <div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">IP File No: 
               <span class="text-blue-800">{{ invoiceItems.invoiceDetails[0].ipfileNo || `-` }}</span></h6>
            </div><div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">ID No: 
               <span class="text-blue-800">{{ invoiceItems.invoiceDetails[0].patientIDNo || `-` }} </span></h6>
            </div> 
            <div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Member No: 
               <span class="text-blue-800">{{ invoiceItems.invoiceDetails[0].memberno || `-` }}</span></h6>
            </div><div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Dependant : 
               <span class="text-blue-800">{{ invoiceItems.invoiceDetails[0].principalOfDependant || `-` }}</span></h6>
            </div>
             </div> -->
             <div class="w-full flex flex-wrap p-1 border-b-dotted border-b-2 border-b-black-600 border-t-dotted border-t-2 border-t-black-600"  v-if="$root.checkAuth('ViewDateOfAdmissionandDischargeOnInvoicePrintOut')">
           <div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Ward: 
               <span class="text-blue-800">{{ invoiceItems.specificVisitRecord.ward || `-` }} </span></h6>
            </div> 
            <div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Bed: 
               <span class="text-blue-800">{{invoiceItems.specificVisitRecord.bed|| `-` }}</span></h6>
            </div><div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Date Admitted : 
               <span class="text-blue-800">{{ invoiceItems.specificVisitRecord.admissionDate|dateFormat }}</span></h6>
            </div><div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Date Discharged : 
               <span class="text-blue-800">{{invoiceItems.specificVisitRecord.disschargeDate|dateFormat}}</span></h6>
            </div>
            </div>
   <table class="table mt-1 mx-1">
      <thead class="text-sm border-t-2 border-b-2 border-gray-400">
        <tr>
          
           <th class="p-tiny">#</th>
           <th class="p-tiny" v-if="$root.checkAuth('ViewItemDateOnInvoicePrintOut')">Date</th>
           <th class="p-tiny">Bill NO</th>
           <th class="p-tiny">Item</th>
          <th class="p-tiny">Description</th>
          <th class="p-tiny">Qty</th>
          <th class="p-tiny text-right">Amount</th>
        </tr>
      </thead>
      <tbody class="text-xs">
        <tr
          v-for="(item, idx) in invoiceItems.invoiceItems"
          :key="idx"
          class="border-b border-gray-400"
        >
        <td class="p-tiny">{{item.invoiceDetailID }} </td>
        
                  <td class="p-tiny"  v-if="$root.checkAuth('ViewItemDateOnInvoicePrintOut')">{{ item.txnDate|dateFormat }}</td>
                  <td class="p-tiny">{{ item.invoiceNo }}</td>
                  <td class="p-tiny">{{ item.item }}</td>
          <td class="p-tiny">{{ item.description }}</td>
          <td class="p-tiny">{{ item.qty }}</td>
          <td class="p-tiny text-right">{{ item.insuranceAmountPaid | numberFormat }}</td>
        </tr>
        <tr>
          <td class="p-tiny text-right font-bold" colspan="3"> </td>
          <td class="p-tiny text-right font-bold">Totals: {{ grandTotal | numberFormat }}</td>
        </tr>
      </tbody>
    </table>
    <div class="w-full flex flex-wrap p-1 mt-1">
                    <div class="flex-1" v-if="$root.checkAuth('DisplayPatientSignatureOnInvoice')">
                        <h5 class="text-sm font-medium">Patient Signature: .........................</h5>
                    </div>
                    <div class="flex-1 text-right">
                        <h5 class="text-sm font-medium">
                          {{ $route.query.postedBy && `Served By: ${$route.query.postedBy}` }}
                          </h5>
                    </div>
                </div>
                <div class=" w-full"  v-if="$root.checkAuth('ViewInvoiceSignatories')">
            <div class="flex-1">
                <h4 class="font-bold text-sm">Prepared By: ____________________________________________________________ Signature:________________________ Date:________________________</h4>
            </div>
            <div class="flex-1 mt-2">
                <h4 class="font-bold text-sm">Approved By: ___________________________________________________________ Signature:________________________ Date:________________________</h4>
        
            </div><div class="flex-1 mt-2">
                <h4 class="font-bold text-sm">Received By:_____________________________________________________________ Signature:________________________ Date:________________________</h4>
        
            </div>
            
        </div>  
    <div class="w-full p-1 text-center">
        <h5 class="font-medium text-sm italic">{{ footerMessage.message }}</h5>
    </div>
     <tail-signature></tail-signature>
  
  </div>
</template>
